import React from 'react';
import { styled } from '@linaria/react';

import GridDemo from './GridDemo';
import GridAreasStructure from './GridAreasStructure';

function GridAreas() {
  return (
    <GridDemo
      initialValues={{}}
      hidePerspectiveControl
      defaultPerspectiveEnabled={false}
      controls={[]}
    >
      {({}) => {
        return (
          <Wrapper>
            <GridAreasStructure withLabels />
          </Wrapper>
        );
      }}
    </GridDemo>
  );
}

const Wrapper = styled.div`
  width: 300px;
  max-width: 100%;
  margin: 16px auto;
  padding-top: 8px;
  aspect-ratio: 1 / 1;
`;

export default GridAreas;
